import { useState, useCallback } from 'react';
import { useDispatch } from "react-redux";
import {
  autoDebtLoadRequest,
  cancelRequest,
  createOneAppClientRequest,
  inprogressRequest, setApproveError,
  setComments, withdrawCarDepositRequest,
} from "../../../../../redux/actions/autoLombardActions";
import {extendedRequestStatuses, kbMessage, RequestStatus, RequestStatuses} from '../../../constants/constants';

export const useRequestStatus = (requestDetails, comments, changes) => {
  const dispatch = useDispatch();
  const [status, setStatus] = useState(null);
  const [isApprovalOpen, setApprovalOpen] = useState(false);
  const [isRejectionOpen, setRejectionOpen] = useState(false);
  const [isKBResponse, setIsKBResponse] = useState(null);
  const [showCommentFields, setShowCommentFields] = useState({
    isShowComments: false,
    isSaveButton: null,
  });

  const actionsMap = {
    [RequestStatus.APPROVED.key]: () => {
      if (requestDetails?.car_request?.estimatedValue <= 0) {
        dispatch(setApproveError('Оценочная стоимость должна быть больше 0'))
        return
      }
      if (requestDetails?.car_request?.estimatedValue < requestDetails?.car_request?.desiredAmount) {
        dispatch(setApproveError('Оценочная стоимость не может быть меньше желаемой суммы'))
        return
      }
      setApprovalOpen(true)
    },
    [RequestStatus.REJECTED_BY_ADMIN.key]: () => setRejectionOpen(true),
    [RequestStatus.REJECTED_BY_CLIENT.key]: () => setRejectionOpen(true),
    [extendedRequestStatuses.CANCEL]: () => setRejectionOpen(true),
    [RequestStatus.REQUIRES_REVISION.key]: () => {
      setStatus('SAVE');
      setShowCommentFields({ isShowComments: true });
    },
    [RequestStatus.CREATED.key]: () => {
      if (requestDetails?.car_request?.id) {
        dispatch(inprogressRequest({ requestId: requestDetails.car_request.id }));
      }
    },
    [extendedRequestStatuses.SAVE]: () => {
      setStatus(RequestStatus.REQUIRES_REVISION.key);
      setShowCommentFields({ isShowComments: false, isSaveButton: null });
      dispatch(setComments({data: comments, id: requestDetails.car_request.id}))
    },
    [extendedRequestStatuses.CANCEL_CLARIFICATION]: () => {
      setStatus(RequestStatus.IN_PROGRESS.key);
      setShowCommentFields({ isShowComments: false });
    },
    [RequestStatus.ACTIVE_NO_COLLATERAL_INFO.key]: () =>
      setStatus(RequestStatus.ACTIVE.key),
    [RequestStatus.MODIFIED.key]: () => {
      if (requestDetails?.car_request?.id) {
        dispatch(inprogressRequest({ requestId: requestDetails.car_request.id }));
      }
    },
    [extendedRequestStatuses.CREATE_CLIENT]: () => {
      if (requestDetails?.client_info?.id) {
        dispatch(createOneAppClientRequest({ 
          albClientId: requestDetails.client_info.id, 
          requestId: requestDetails.car_request.id}));
      }
    },
    [extendedRequestStatuses.DEBT_LOAD]: () => {
      if (!requestDetails?.credit_report_calculation) {
        setIsKBResponse(kbMessage)
      } else {
        const data = createDebtLaodPayload(requestDetails, changes)
        dispatch(autoDebtLoadRequest({ 
          data,
          oneClientId: requestDetails?.client_info.oneAppId,
          requestId: requestDetails.car_request.id}));
      }
    },
    [RequestStatuses.COMPLETED_PENDING_WITHDRAWAL]: () => {
      dispatch(withdrawCarDepositRequest({
        requestId: requestDetails.car_request.id
      }))
    },
    [RequestStatus.EXPIRED.key]: () => {
      if (requestDetails?.car_request?.id) {
        dispatch(cancelRequest({ requestId: requestDetails.car_request.id }));
      }
    },
  };

  const handleStatusChange = useCallback((newStatus) => {
    const actionHandler = actionsMap[newStatus];
    if (actionHandler) {
      actionHandler();
    }
  }, [requestDetails, comments, changes]);

  const createDebtLaodPayload = (requestDetails, changes) => {
    const incomeConfirmed = changes.incomeVerificationDocument

    return {
      jobType: requestDetails.client_info.jobType,
      jobIndustry: requestDetails.client_info.jobIndustry,
      avgMonthlyIncome: requestDetails.client_info.avgMonthlyIncome,
      noCreditHistory: requestDetails.credit_report_calculation.noCreditHistory,
      accessDeniedByClient: requestDetails.credit_report_calculation.accessDeniedByClient,
      creditAmountSum: requestDetails.credit_report_calculation.creditAmountSum,
      creditOverdueSum: requestDetails.credit_report_calculation.creditOverdueSum,
      suretySum: requestDetails.credit_report_calculation.totalSuretySum,
      desiredTerm: requestDetails.car_request.desiredTerm,
      desiredAmount: requestDetails.car_request.desiredAmount,
      incomeConfirmed,
      isAutoOnline: true,
    }
  }

  return {
    status,
    isApprovalOpen,
    isRejectionOpen,
    isKBResponse,
    showCommentFields,
    setStatus,
    setApprovalOpen,
    setRejectionOpen,
    setShowCommentFields,
    setIsKBResponse,
    handleStatusChange,
  };
};